/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'department': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<text text-anchor="middle" dominant-baseline="central" x="50%" y="50%" font-weight="900" font-size="9" font-family="Arial">Abt</text>'
  }
})
